import api, { api2 } from "../controllers/api";
import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
const BASE_URL = process.env.REACT_APP_SERVER_URL;
const postData = async (url, data, formdata) => {
  try {
    const token = Cookies.get("authToken");
    let header = {};
    if (formdata) {
      header = {
        Authorization: `carrum ${token}`,
        // 'Content-Type': 'multipart/form-data',
      };
    } else {
      header = {
        Authorization: `carrum ${token}`,
        "Content-Type": "application/json",
      };
    }

    const result = await fetch(`${BASE_URL + url}`, {
      method: "POST",
      headers: header,
      // headers: {
      //     'Content-Type': 'application/json',
      //     // 'Content-Type': 'multipart/form-data',
      //     'Authorization': `carrum ${token}`,
      // },
      body: data,
    });
    return result;
  } catch (error) {
    console.error(error);
  }
};

export const allFleetHubAPI = async (hubId) => {
  // /scheme/get?hub_id=f8ff9964-ce4d-4de4-beee-e9b4409a3015
  try {
    // {{baseurl}}/fleet/all/?limit=100000&hub_id=61ebf028-508d-11ef-a8c2-0adb4ae21b89
    const url = `/fleet/all?limit=100000${hubId ? `&hub_id=${hubId}` : ""}`;
    const result = api2.get(url);

    return result;
  } catch (error) {
    console.error(error);
  }
};

export const allHub = async () => {
  try {
    // {{baseurl}}/fleet/all/?limit=100000&hub_id=2475d7f6-6961-4322-837b-618f848c07fc
    const url = `/hub/?limit=100000`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    console.error(error);
  }
};

export const Vehicle_Type_DetailsAPI = async () => {
  try {
    const url = `/fleet/car_type`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const UberAssignedDriverAPI = async (id) => {
  try {
    const url = `/fleet/vehicleUberAssign?vehicle_id=${id}`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

// /fleet/singleDoc/:id
export const fleetRecordsWithIdAPI = async (Id) => {
  // /scheme/get?hub_id=f8ff9964-ce4d-4de4-beee-e9b4409a3015
  try {
    // {{baseurl}}/fleet/all/?limit=100000&hub_id=2475d7f6-6961-4322-837b-618f848c07fc
    let result = undefined;
    const url = `/fleet/single/${Id}`;
    if (Id) {
      result = await api.get(url);
    }
    return result;
  } catch (error) {
    console.error(error);
  }
};

export const fleetFormParkingUpdate = async (fleetID, newObj) => {
  try {
    const url = `/fleet/uploadDoc/${fleetID}`;
    const result = await api.post(url, newObj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const changeMantaincetoRtaPost = async (fleetID, obj) => {
  try {
    const url = `/fleet/changeStatusvehicle/torta/${fleetID}`;
    const result = await api.put(url, obj);
    return result;
  } catch (error) {
    return error;
  }
};

export const fleetFormProcurementUpdate = async (fleetID, newObj) => {
  try {
    const url = `/fleet/updateVehicle/${fleetID}`;
    const result = api.put(url, newObj);
    return result;

    // navigate("/dashboard");
  } catch (error) {
    return error;
  }
};

export const assignedDriverFleetAPI = async (fleetID) => {
  try {
    // {{baseurl}}/fleet/all/?limit=100000&hub_id=2475d7f6-6961-4322-837b-618f848c07fc
    const url = `/fleet/getvehicleAssignToDriver/${fleetID}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
  }
};

// replace financier with reg_number, model, variant, chassis_number, engine_number, financier, seller, Fastag_company
export const fleetFormDropdownListsAPI = async () => {
  try {
    let url = "";
    let result = "";
    const arr = ["financier", "model", "variant", "seller", "Fastag_company"];
    const prarray = arr?.map(async (entity) => {
      url = `/fleet/info/${entity}`;
      result = await api.get(url);
      return result;
    });
    const responses = await Promise.all(prarray);
    const result_obj = responses.reduce((acc, cv) => {
      const output = cv.results;
      if (Array.isArray(output) && output.length) {
        const responseType = Object.keys(output[0])[0];
        acc[responseType] = output.map((obj) => {
          return obj[responseType];
        });
      }
      return acc;
    }, {});
    return result_obj;
  } catch (error) {
    return error;
  }
};

export const uploadFleetDocuments = async (fleetID, formData, docType, setImagesChanges) => {
  try {
    const url = `/fleet/uploadDoc/${fleetID}`;
    const result = await postData(url, formData, true);
    const newResult = await result.json();
    // setImagesChanges((prev)=>prev+1);
    return newResult;
  } catch (error) {
    throw error;
  }
};

// export const uploadFleetDocuments = async (fleetID, docType, formData) => {
//     try {
//         const url = `/fleet/uploadDoc/${fleetID}`;
//         // const formData = new FormData();
//         // formData.append(docType, file)
//         const result =  await postData(url,formData,true)
//         // const newResult = await result.json()
//         // setImagesChanges((prev)=>prev+1);
//         // return newResult;
//         return result;
//     } catch (error) {
//         throw error
//     }
// }

// /fleet/statusChange/:id
export const statusFleetAPI = async (fleetID, newObj) => {
  try {
    const url = `/fleet/statusChange/${fleetID}`;
    const result = await api.post(url, newObj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetRecoveryAgent = async () => {
  try {
    const url = `/management/recovery/getRecoveryAgentList`;
    const result = api2.get(url);
    return result;
  } catch (error) {
    console.error(error);
  }
};

export const fleetRecoveryAgentPost = async (recoveryId, newObj) => {
  try {
    const url = `/management/recovery/updateRequest/${recoveryId}`;
    const result = await api.put(url, newObj);
    return result;
  } catch (error) {
    throw error;
  }
};
